const { declareVueComponent } = require("/vodalys/vvuejs/vueRegister.mjs");

import FConsole17Tabs from './component/FConsole17Tabs.vue'
declareVueComponent('FConsole17Tabs', FConsole17Tabs)
